import { render, staticRenderFns } from "./ItemForm.vue?vue&type=template&id=e011b764&scoped=true"
import script from "./ItemForm.vue?vue&type=script&lang=js"
export * from "./ItemForm.vue?vue&type=script&lang=js"
import style0 from "./ItemForm.vue?vue&type=style&index=0&id=e011b764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e011b764",
  null
  
)

export default component.exports